import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'premium';
}
export function CTAButton({
  children,
  href,
  className = '',
  onClick,
  variant = 'primary'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'pricing';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    relative inline-flex items-center justify-center w-full
    px-5 py-4 sm:px-6 sm:py-5
    font-bold text-sm sm:text-base uppercase tracking-wide
    rounded-xl
    hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]
    transition-all duration-200 shadow-md
    ${variant === 'premium' ? 'bg-brand-gold text-white' : 'bg-brand-olive text-white'}
    ${className}
  `;
  const content = <span className="flex items-center text-center justify-center gap-2 leading-tight" data-id="element-49">
      <span data-id="element-50">{children}</span>
    </span>;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} target={href.startsWith('http') ? '_self' : '_self'} data-id="element-51">
        {content}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-52">
      {content}
    </button>;
}